import React from 'react'
import ManageProspect from '../../modules/ManageProspect'

const ManageProspectPage = () => {
  return <ManageProspect />
}

export default ManageProspectPage
